import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ScrollText } from "lucide-react";
import DialplanEditor from "../components/sip/DialplanEditor";
import ProfileMenu from "../components/ProfileMenu";

export default function SipDialplanPage() {
  const nav = useNavigate();
  return (
    <div className="au-root" data-theme="sip">
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 16,
          flexWrap: "wrap",
          padding: "16px 24px",
          borderBottom: "1px solid var(--au-hair)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <button
            className="au-pill au-pill-glass au-pill-sm"
            onClick={() => nav("/dashboard")}
          >
            <ArrowLeft size={16} /> Dashboard
          </button>
          <h1 style={{ fontSize: "1.25rem", display: "flex", alignItems: "center", gap: 8 }}>
            <ScrollText size={20} style={{ color: "var(--au-accent-ink)" }} />
            SIP Dialplan Editor
          </h1>
        </div>
        <ProfileMenu />
      </header>
      <main className="au-container" style={{ padding: "24px 24px 48px", maxWidth: 1280 }}>
        <DialplanEditor />
      </main>
    </div>
  );
}
